module.exports = __webpack_public_path__ + "img/planCuentasIngresos.7797d191.svg";